import { ForwardedRef, forwardRef } from 'react';
import { SearchField } from '@bgzt/ui';
import { Action, FilterSection } from '~/components';

import styles from './Wihtin.module.css';

type Props = {
  onChange: (action: Action) => void;
  within?: string;
  title?: string;
};

export const Within = forwardRef(function Within(
  { onChange, within, title = '' }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <FilterSection title={title} ref={ref}>
      <div className={styles.container}>
        <SearchField
          placeholder="검색어를 입력해주세요"
          onChange={(e) => {
            onChange({ type: 'within', payload: e.target.value || null });
          }}
          onReset={() => {
            onChange({ type: 'within', payload: null });
          }}
          value={within}
        />
      </div>
    </FilterSection>
  );
});
